import { dispatch } from "../store/store";
import {
  getPatientPrescriptionsData,
  setIsPatientPrescriptionsLoading,
  updatePatientPrescriptionData,
  verifyPinForPrescriptionApprovalData,
  patientPrescriptionBulkUpdateData,
  getPatientPrescriptionByIdData,
  setPrescriptionImagePreviewData,
  setPreviewPrescriptionData,
  getPrescriptionByPrescriptionIdData,
  setShowPrintPreviewLoadingData,
  declinePrescriptionByIdData,
  setConsultationPrescriptionImagePreviewData,
  patientPrescriptionDownloadPdfForVaccineData
} from "../features/patientPrescriptionSlice/patientPrescriptionSlice";
import { logErrorWithPayload } from "../services/logService";
import {
  setVaccinePdfDownloadPayload
} from "@/features/patientPrescriptionSlice/patientPrescriptionSlice";

const reducerName = "patientPrescription";

// #region State Setters
export const setPatientPrescriptionsLoading = (isLoading) => {
  dispatch(setIsPatientPrescriptionsLoading(isLoading));
};
export const setPrescriptionImagePreview = (data) => {
  dispatch(setPrescriptionImagePreviewData(data));
};
export const setPreviewPrescription = (data) => {
  dispatch(setPreviewPrescriptionData(data));
};
export const setShowPrintPreviewLoading = (data) => {
  dispatch(setShowPrintPreviewLoadingData(data));
};
export const setConsultationPrescriptionImagePreview = (data) => {
  dispatch(setConsultationPrescriptionImagePreviewData(data));
};
export const setVaccinePdfDownloadData = (data) => {
  dispatch(setVaccinePdfDownloadPayload(data));
};
// #endregion

// #region API getter/caller functions for components usage to dispatch REDUX extra reducers
export const getPatientPrescriptions = async (companyID) => {
  let result = null;
  try {
    result = await dispatch(getPatientPrescriptionsData(companyID)).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }
  return result;
};

export const updatePatientPrescription = async (data) => {
  let result = null;
  try {
    result = await dispatch(updatePatientPrescriptionData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }
  return result;
};

export const verifyPinForPrescriptionApproval = async (Pin) => {
  let result = null;
  try {
    result = await dispatch(verifyPinForPrescriptionApprovalData(Pin)).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }
  return result;
};

export const patientPrescriptionBulkUpdate = async (data) => {
  let result = null;
  try {
    result = await dispatch(patientPrescriptionBulkUpdateData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }
  return result;
};

export const patientPrescriptionDownloadPdfForVaccine = async (data) => {
  let result = null;
  try {
    result = await dispatch(patientPrescriptionDownloadPdfForVaccineData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }
  return result;
};

export const getPatientPrescriptionById = async (data) => {
  let result = null;
  try {
    result = await dispatch(getPatientPrescriptionByIdData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }
  return result;
};
export const getPrescriptionByPrescriptionId = async (data) => {
  let result = null;
  try {
    result = await dispatch(getPrescriptionByPrescriptionIdData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }
  return result;
};
export const declinePrescriptionById = async (data) => {
  let result = null;
  try {
    result = await dispatch(declinePrescriptionByIdData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }
  return result;
};
// #endregion
